import type { PlayedToHandicap } from "../../domain/round/played-to-handicap.js";

export function playedToHandicapLabel(result: PlayedToHandicap): string | null {
  if (result.status !== "before-pcc") return null;
  const value = Math.abs(result.value).toFixed(1).replace(".", ",");
  return `Played to ${result.value < 0 ? "+" : ""}${value} HC`;
}

export function playedToHandicapReason(result: PlayedToHandicap): string {
  if (result.status === "before-pcc")
    return "18-hole Score Differential before the official playing conditions calculation (PCC). Based on the recorded tee and adjusted hole scores. This does not update your Handicap Index.";
  switch (result.reason) {
    case "expected-score-required":
      return "Available for 18 holes. Shorter rounds need the official expected-score calculation.";
    case "missing-rating":
      return "Tee rating, slope or hole data missing.";
    case "missing-handicap":
      return "Handicap at the start of the round missing.";
    case "incomplete-scores":
      return "Complete hole scores required.";
    case "not-completed":
      return "Available after the round is completed.";
    case "unsupported-round":
      return "Available for individual outdoor stroke play and Stableford.";
  }
}
